import getters from './getters';
// eslint-disable-next-line import/no-cycle
import actions from './actions';
import mutations from './mutations';

const state = {
  driverInfo: {},
  driverAvatar: null,
  carPlateSelect: '',
  vehicles: [],
  vehicleSelected: {},
  firstLogin: true,
  driverId: '',
  notifications: [],
  operationsCardFuel: null,
  infoUser: {},
  messageContact: {
    Documentos: []
  },
  townsCache: {},
  townsProvinceCodeCache: [],
  patternsCMS: null,
  historicalsNextInterventions: null,
  historicalsInterventions: null,
  urlIAldPitStop: '',
  legalConditions: null,
  typesIncidents: null,
  level2: null,
  level3: null,
  replaceVehicle: {
    idUser: null,
    category: null,
    productCode: null,
    vehicle: {},
    driver: {},
    repairShop: {},
    managmentShop: {},
    comment: { locality: null }
  },
  serCard: {
    plate: null,
    userApplication: null,
    webType: 1
  },
  authorizationDepositExit: {
    plate: null,
    userApplication: null,
    webType: 1
  },
  authorizationAccessoriesAssembly: {
    plate: null,
    userApplication: null,
    webType: 1,
    accesoryType: null
  },
  foreignNational: {
    plate: null,
    userApplication: null,
    webType: 1,
    countryToVisit: null,
    nive: true,
    additionalData: {
      name: null,
      lastName: null,
      country: null,
      province: null,
      population: null,
      postCode: null,
      address: null,
      phone: null,
      email: null
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
